'use client';
import { AuthButton } from '@/app/components/auth-button';

export function AppHeader() {
  return (
    <header className="bg-gradient-to-r from-coral-500 to-coral-600 shadow-md w-full">
      <div className="max-w-[1200px] mx-auto w-full px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🍜</span>
          <h1 className="text-lg font-display font-bold text-white tracking-tight">
            Food Finder Sài Gòn
          </h1>
        </div>
        {/* <AuthButton /> — temporarily hidden until auth flow is ready */}
      </div>
    </header>
  );
}
